<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-10 mx-auto">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <h6 class="mb-0 me-auto">Configuración</h6>
              <argon-button color="success" size="sm" :disabled="saving" @click="save">
                {{ saving ? 'Guardando...' : 'Guardar' }}
              </argon-button>
            </div>
          </div>
          <div class="card-body">
            <form @submit.prevent="save">
              <div class="row g-3">
                <div class="col-md-6">
                  <label class="form-label">Nombre de la empresa</label>
                  <input v-model="form.company_name" type="text" class="form-control" placeholder="Nombre de la empresa">
                </div>
                <div class="col-md-6">
                  <label class="form-label">Correo electrónico</label>
                  <input v-model="form.email" type="email" class="form-control" placeholder="correo@empresa.com">
                </div>
                <div class="col-md-6">
                  <label class="form-label">Teléfono</label>
                  <input v-model="form.phone" type="text" class="form-control" placeholder="Teléfono">
                </div>
                <div class="col-md-6">
                  <label class="form-label">Dirección</label>
                  <input v-model="form.address" type="text" class="form-control" placeholder="Dirección">
                </div>
                <div class="col-12">
                  <label class="form-label">Descripción</label>
                  <textarea
                    v-model="form.description"
                    class="form-control"
                    rows="3"
                    placeholder="Descripción de la empresa"
                  ></textarea>
                </div>

                <div class="col-12">
                  <hr class="my-2" />
                  <h6 class="mb-3">Colores del tema</h6>
                  <small class="text-muted d-block mb-3">
                    El color primario define el fondo del panel (degradado). El color warning se mezcla al final del degradado y en botones de acento. El color del menú aplica solo a las etiquetas del menú lateral (no a los iconos).
                  </small>
                </div>
                <div class="col-md-6">
                  <label class="form-label">Color primario (fondo)</label>
                  <div class="d-flex align-items-center gap-3">
                    <input
                      v-model="form.primary_color"
                      type="color"
                      class="form-control form-control-color theme-color-input"
                      title="Color primario"
                    />
                    <input
                      v-model="form.primary_color"
                      type="text"
                      class="form-control"
                      maxlength="7"
                      placeholder="#2C3A59"
                      pattern="^#[0-9A-Fa-f]{6}$"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="form-label">Color warning (acento)</label>
                  <div class="d-flex align-items-center gap-3">
                    <input
                      v-model="form.warning_color"
                      type="color"
                      class="form-control form-control-color theme-color-input"
                      title="Color warning"
                    />
                    <input
                      v-model="form.warning_color"
                      type="text"
                      class="form-control"
                      maxlength="7"
                      placeholder="#f9b002"
                      pattern="^#[0-9A-Fa-f]{6}$"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="form-label">Color de letra del menú</label>
                  <div class="d-flex align-items-center gap-3">
                    <input
                      v-model="form.menu_text_color"
                      type="color"
                      class="form-control form-control-color theme-color-input"
                      title="Color de letra del menú"
                    />
                    <input
                      v-model="form.menu_text_color"
                      type="text"
                      class="form-control"
                      maxlength="7"
                      placeholder="#67748E"
                      pattern="^#[0-9A-Fa-f]{6}$"
                    />
                  </div>
                </div>
                <div class="col-12">
                  <div class="theme-preview" :style="themePreviewStyle">
                    Vista previa del fondo
                  </div>
                  <div class="menu-text-preview mt-2" :style="menuTextPreviewStyle">
                    <i class="fas fa-home me-2" :style="{ color: form.warning_color }"></i>
                    <span>Vista previa del menú lateral</span>
                  </div>
                </div>

                <div class="col-12">
                  <hr class="my-2" />
                  <h6 class="mb-3">WooCommerce / WordPress</h6>
                </div>
                <div class="col-md-12">
                  <label class="form-label">URL de WordPress</label>
                  <input
                    v-model="form.wordpress_url"
                    type="url"
                    class="form-control"
                    placeholder="https://racingbike.co"
                  />
                  <small class="text-muted">Sitio donde está instalado WooCommerce (sin barra final).</small>
                </div>
                <div class="col-md-6">
                  <label class="form-label">Consumer key</label>
                  <input
                    v-model="form.wordpress_consumer_key"
                    type="password"
                    class="form-control"
                    placeholder="ck_..."
                    autocomplete="off"
                  />
                </div>
                <div class="col-md-6">
                  <label class="form-label">Consumer secret</label>
                  <input
                    v-model="form.wordpress_consumer_secret"
                    type="password"
                    class="form-control"
                    placeholder="cs_..."
                    autocomplete="off"
                  />
                </div>
                <div class="col-12">
                  <small class="text-muted">
                    Cree las claves en WordPress: WooCommerce → Ajustes → Avanzado → REST API.
                    La sincronización en inventario busca el producto por SKU (campo ref = SKU de WooCommerce).
                  </small>
                </div>

                <div class="col-12">
                  <hr class="my-2" />
                  <h6 class="mb-3">Módulo de trabajos</h6>
                </div>
                <div class="col-md-4">
                  <label class="form-label">Comisión del empleado (%)</label>
                  <input
                    v-model.number="form.employee_commission_percent"
                    type="number"
                    min="0"
                    max="100"
                    step="0.01"
                    class="form-control"
                    placeholder="70"
                  />
                  <small class="text-muted d-block mt-1">
                    Porcentaje de ganancia del empleado sobre el precio del trabajo en /worker-tasks.
                  </small>
                </div>

                <div class="col-12">
                  <label class="form-label d-block mb-2">Módulos</label>
                  <div class="form-check form-switch d-flex align-items-center gap-2">
                    <input
                      id="service_orders_enabled"
                      v-model="form.service_orders_enabled"
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                    />
                    <label class="form-check-label mb-0" for="service_orders_enabled">
                      Orden de servicio activa
                      <small class="text-muted d-block">
                        Si está inactiva, no aparece en el menú lateral.
                      </small>
                    </label>
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="form-label">Logo claro</label>
                  <input type="file" class="form-control" accept="image/*" @change="onFileChange($event, 'logo_path')">
                  <div v-if="preview.logo_path" class="mt-2 text-center">
                    <img :src="preview.logo_path" alt="Logo claro" class="settings-preview-img">
                  </div>
                </div>
                <div class="col-md-4">
                  <label class="form-label">Logo oscuro</label>
                  <input type="file" class="form-control" accept="image/*" @change="onFileChange($event, 'logo_path_dark')">
                  <div v-if="preview.logo_path_dark" class="mt-2 text-center">
                    <img :src="preview.logo_path_dark" alt="Logo oscuro" class="settings-preview-img">
                  </div>
                </div>
                <div class="col-md-4">
                  <label class="form-label">Favicon</label>
                  <input type="file" class="form-control" accept="image/*,.ico" @change="onFileChange($event, 'favicon_path')">
                  <div v-if="preview.favicon_path" class="mt-2 text-center">
                    <img :src="preview.favicon_path" alt="Favicon" class="settings-preview-img settings-preview-img--small">
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ArgonButton from '@/components/ArgonButton.vue';
import {
  applyThemeColors,
  buildThemeBgGradient,
  DEFAULT_PRIMARY,
  DEFAULT_WARNING,
  DEFAULT_MENU_TEXT,
  normalizeHex,
} from '@/utils/themeColors';

const body = document.getElementsByTagName('body')[0];

export default {
  name: 'SettingsForm',
  components: { ArgonButton },
  data() {
    return {
      saving: false,
      apiUrl: process.env.VUE_APP_API_IMAGE_URL || process.env.VUE_APP_API_BASE_URL,
      form: {
        company_name: '',
        description: '',
        email: '',
        phone: '',
        address: '',
        service_orders_enabled: true,
        employee_commission_percent: 70,
        wordpress_url: '',
        wordpress_consumer_key: '',
        wordpress_consumer_secret: '',
        primary_color: DEFAULT_PRIMARY,
        warning_color: DEFAULT_WARNING,
        menu_text_color: DEFAULT_MENU_TEXT,
      },
      files: {
        logo_path: null,
        logo_path_dark: null,
        favicon_path: null,
      },
      preview: {
        logo_path: '',
        logo_path_dark: '',
        favicon_path: '',
      },
    };
  },
  computed: {
    themePreviewStyle() {
      return {
        background: buildThemeBgGradient(this.form.primary_color, this.form.warning_color),
      };
    },
    menuTextPreviewStyle() {
      return {
        color: normalizeHex(this.form.menu_text_color, DEFAULT_MENU_TEXT),
        background: '#fff',
        border: '1px solid rgba(0, 0, 0, 0.08)',
        borderRadius: '8px',
        padding: '10px 14px',
        fontSize: '0.875rem',
        fontWeight: '600',
      };
    },
  },
  watch: {
    'form.primary_color'() {
      this.previewTheme();
    },
    'form.warning_color'() {
      this.previewTheme();
    },
    'form.menu_text_color'() {
      this.previewTheme();
    },
  },
  methods: {
    previewTheme() {
      applyThemeColors({
        primary_color: this.form.primary_color,
        warning_color: this.form.warning_color,
        menu_text_color: this.form.menu_text_color,
      });
    },
    buildImageUrl(path) {
      if (!path) return '';
      if (path.startsWith('http') || path.startsWith('data:')) return path;
      return `${this.apiUrl}${path}`;
    },
    onFileChange(event, field) {
      const file = event.target.files?.[0];
      this.files[field] = file || null;
      if (file) {
        this.preview[field] = URL.createObjectURL(file);
      }
    },
    async loadSettings() {
      try {
        const response = await this.$store.dispatch('settings/get');
        if (response?.data) {
          const data = response.data;
          this.form = {
            company_name: data.company_name || '',
            description: data.description || '',
            email: data.email || '',
            phone: data.phone || '',
            address: data.address || '',
            service_orders_enabled: data.service_orders_enabled !== false && data.service_orders_enabled !== 0,
            employee_commission_percent: Number(data.employee_commission_percent ?? 70),
            wordpress_url: data.wordpress_url || '',
            wordpress_consumer_key: data.wordpress_consumer_key || '',
            wordpress_consumer_secret: data.wordpress_consumer_secret || '',
            primary_color: normalizeHex(data.primary_color, DEFAULT_PRIMARY),
            warning_color: normalizeHex(data.warning_color, DEFAULT_WARNING),
            menu_text_color: normalizeHex(data.menu_text_color, DEFAULT_MENU_TEXT),
          };
          applyThemeColors(this.form);
          this.preview.logo_path = this.buildImageUrl(data.logo_path);
          this.preview.logo_path_dark = this.buildImageUrl(data.logo_path_dark);
          this.preview.favicon_path = this.buildImageUrl(data.favicon_path);
        }
      } catch (error) {
        console.error('Error loading settings:', error);
        await Swal.fire('Error', 'No se pudo cargar la configuración.', 'error');
      }
    },
    async save() {
      this.form.primary_color = normalizeHex(this.form.primary_color, DEFAULT_PRIMARY);
      this.form.warning_color = normalizeHex(this.form.warning_color, DEFAULT_WARNING);
      this.form.menu_text_color = normalizeHex(this.form.menu_text_color, DEFAULT_MENU_TEXT);
      this.saving = true;
      try {
        const formData = new FormData();
        Object.entries(this.form).forEach(([key, value]) => {
          if (key === 'service_orders_enabled') {
            formData.append(key, value ? '1' : '0');
            return;
          }
          formData.append(key, value ?? '');
        });
        Object.entries(this.files).forEach(([key, file]) => {
          if (file) {
            formData.append(key, file);
          }
        });

        const response = await this.$store.dispatch('settings/save', formData);
        if (response && response.status >= 200 && response.status < 300) {
          this.files = { logo_path: null, logo_path_dark: null, favicon_path: null };
          await this.loadSettings();
          await Swal.fire('Éxito', 'La configuración se guardó correctamente.', 'success');
        } else {
          throw new Error(response?.data?.message || 'Error al guardar la configuración');
        }
      } catch (error) {
        console.error('Error saving settings:', error);
        const msg = error?.response?.data?.message || error.message || 'No se pudo guardar la configuración.';
        await Swal.fire('Error', msg, 'error');
      } finally {
        this.saving = false;
      }
    },
  },
  async mounted() {
    await this.loadSettings();
    this.$store.state.isAbsolute = false;
  },
  beforeMount() {
    this.$store.state.imageLayout = 'profile-overview';
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add('profile-overview');
  },
  beforeUnmount() {
    applyThemeColors(this.$store.state.settings?.data || {});
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = 'default';
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove('profile-overview');
  },
};
</script>

<style scoped>
.settings-preview-img {
  max-height: 80px;
  max-width: 100%;
  object-fit: contain;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 6px;
  background: #fff;
}

.settings-preview-img--small {
  max-height: 48px;
  max-width: 48px;
}

.theme-color-input {
  width: 3.5rem;
  height: 2.5rem;
  padding: 0.2rem;
  flex-shrink: 0;
}

.theme-preview {
  height: 72px;
  border-radius: 8px;
  display: flex;
  align-items: flex-end;
  padding: 10px 14px;
  color: #fff;
  font-size: 0.8rem;
  font-weight: 600;
  border: 1px solid rgba(0, 0, 0, 0.08);
}
</style>
